export default __webpack_public_path__ + "static/media/clinic-image-02.c4e2f0aa.png";